import React from 'react';
import PropTypes from 'prop-types';
import './FileStorageAppView.scss';
import FileStorageAppHeader from 'Components/FileStorageAppHeader';
import IntegrationIframe from 'Components/IntegrationIframe';
import NoPermissionView from './NoPermissionView';

class FileStorageAppView extends React.Component {
	state = { displayType: 'list' };

	render() {
		const hasFolderStructure = Tools.FeatureHelper.hasSoftDeployAccess('FILE_FOLDER_STRUCTURE');
		const { app, objectId, displayTypeFromParent } = this.props;
		const displayType =
			hasFolderStructure && displayTypeFromParent ? displayTypeFromParent : this.state.displayType;

		return (
			<div className="FileStorageView">
				<FileStorageAppHeader
					app={app}
					displayType={displayType}
					onDisconnect={this.props.onDisconnect(app.id)}
					onChangeDisplayType={displayType => this.setState({ displayType })}
				/>
				{app.permissionDenied ? (
					<NoPermissionView />
				) : (
					<IntegrationIframe
						type={displayType}
						integrationId={app.id}
						objectId={objectId}
						name="FileStorageDisplayFiles"
					/>
				)}
			</div>
		);
	}
}

FileStorageAppView.propTypes = {
	app: PropTypes.object.isRequired,
	objectId: PropTypes.number.isRequired,
	onDisconnect: PropTypes.func.isRequired,
	displayTypeFromParent: PropTypes.string
};

export default FileStorageAppView;
